import { useMediaQuery } from 'react-responsive';

export const useScreenSizeDetection = () => {
  const isDesktopOrLaptop = useMediaQuery({ minWidth: 994 });
  const isTablet = useMediaQuery({ minWidth: 569, maxWidth: 993 });
  const isMobile = useMediaQuery({ maxWidth: 568 });

  return {
    isDesktopOrLaptop,
    isTablet,
    isMobile,
  };
};
